"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = theme => ({
  '@global': {
    '.emoji-mart,\n.emoji-mart *': {
      boxSizing: 'border-box',
      lineHeight: '1.15'
    },
    '.emoji-mart': {
      fontFamily: '-apple-system, BlinkMacSystemFont, \'Helvetica Neue\', sans-serif',
      fontSize: '16px',
      display: 'inline-block',
      color: '#222427',
      border: '1px solid #d9d9d9',
      borderRadius: '5px',
      background: '#fff'
    },
    '.emoji-mart .emoji-mart-emoji': {
      padding: '6px'
    },
    '.emoji-mart-bar': {
      border: '0 solid #d9d9d9'
    },
    '.emoji-mart-bar:first-child': {
      borderBottomWidth: '1px',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px'
    },
    '.emoji-mart-bar:last-child': {
      display: 'none',
      borderTopWidth: '1px',
      borderBottomLeftRadius: '5px',
      borderBottomRightRadius: '5px'
    },
    '.emoji-mart-anchors': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '0 6px',
      lineHeight: '0'
    },
    '.emoji-mart-anchor': {
      position: 'relative',
      display: 'block',
      flex: '1 1 auto',
      color: '#858585',
      textAlign: 'center',
      padding: '12px 4px',
      overflow: 'hidden',
      transition: 'color .1s ease-out',
      margin: '0',
      boxShadow: 'none',
      background: 'none',
      border: 'none'
    },
    '.emoji-mart-anchor:focus': {
      outline: '0'
    },
    '.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected': {
      color: `${theme.primaryColor}!important`
    },
    '.emoji-mart-anchor-selected .emoji-mart-anchor-bar': {
      bottom: '0'
    },
    '.emoji-mart-anchor-bar': {
      position: 'absolute',
      bottom: '-3px',
      left: '0',
      width: '100%',
      height: '3px',
      backgroundColor: `${theme.primaryColor}!important`
    },
    '.emoji-mart-anchors i': {
      display: 'inline-block',
      width: '100%',
      maxWidth: '22px'
    },
    '.emoji-mart-anchors svg,\n.emoji-mart-anchors img': {
      fill: 'currentColor',
      height: '18px',
      width: '18px'
    },
    '.emoji-mart-scroll': {
      overflowY: 'scroll',
      overflowX: 'hidden',
      height: '270px',
      padding: '0 6px 6px 6px',
      willChange: 'transform'
    },
    '.emoji-mart-search': {
      display: 'none',
      marginTop: '6px',
      padding: '0 6px',
      position: 'relative'
    },
    '.emoji-mart-search input': {
      fontSize: '16px',
      display: 'block',
      width: '100%',
      padding: '5px 25px 6px 10px',
      borderRadius: '5px',
      border: '1px solid #d9d9d9',
      outline: '0'
    },
    // eslint-disable-next-line max-len
    '.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration': {
      WebkitAppearance: 'none'
    },
    '.emoji-mart-search-icon': {
      position: 'absolute',
      top: '7px',
      right: '11px',
      zIndex: '2',
      padding: '2px 5px 1px',
      border: 'none',
      background: 'none'
    },
    '.emoji-mart-category .emoji-mart-emoji span': {
      zIndex: '1',
      position: 'relative',
      textAlign: 'center',
      cursor: 'default'
    },
    '.emoji-mart-category .emoji-mart-emoji:hover:before': {
      zIndex: '0',
      content: '',
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: '#f4f4f4',
      borderRadius: '100%'
    },
    '.emoji-mart-category-label': {
      fontSize: 12,
      zIndex: '2',
      position: ['relative', '-webkit-sticky', 'sticky'],
      top: '0'
    },
    '.emoji-mart-category-label:first-child': {
      marginTop: 4
    },
    '.emoji-mart-category-label span': {
      display: 'block',
      width: '100%',
      fontWeight: '500',
      padding: '5px 6px',
      backgroundColor: ['#fff', 'rgba(255, 255, 255, .95)']
    },
    '.emoji-mart-category-list': {
      margin: '0',
      padding: '0'
    },
    '.emoji-mart-category-list li': {
      listStyle: 'none',
      margin: '0',
      padding: '0',
      display: 'inline-block'
    },
    '.emoji-mart-emoji': {
      position: 'relative',
      display: 'inline-block',
      fontSize: '0',
      margin: '0',
      padding: '0',
      border: 'none',
      background: 'none',
      boxShadow: 'none'
    },
    '.emoji-mart-emoji-native': {
      fontFamily: '\'Segoe UI Emoji\', \'Segoe UI Symbol\', \'Segoe UI\', \'Apple Color Emoji\', \'Twemoji Mozilla\', \'Noto Color Emoji\', \'Android Emoji\'' // eslint-disable-line max-len
    },
    '.emoji-mart-no-results': {
      fontSize: '14px',
      textAlign: 'center',
      paddingTop: '70px',
      color: '#858585'
    },
    '.emoji-mart-no-results-img': {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '50%'
    },
    '.emoji-mart-no-results .emoji-mart-category-label': {
      display: 'none'
    },
    '.emoji-mart-no-results .emoji-mart-no-results-label': {
      marginTop: '.2em'
    },
    '.emoji-mart-no-results .emoji-mart-emoji:hover:before': {
      content: 'none'
    },
    '.emoji-mart-preview': {
      position: 'relative',
      height: '70px'
    },
    '.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    },
    '.emoji-mart-preview-emoji': {
      left: '12px'
    },
    '.emoji-mart-preview-data': {
      left: '68px',
      right: '12px',
      wordBreak: 'break-all'
    },
    '.emoji-mart-preview-skins': {
      right: '30px',
      textAlign: 'right'
    },
    '.emoji-mart-preview-skins.custom': {
      right: '10px',
      textAlign: 'right'
    },
    '.emoji-mart-preview-name': {
      fontSize: '14px'
    },
    '.emoji-mart-preview-shortname': {
      fontSize: '12px',
      color: '#888'
    },
    // eslint-disable-next-line max-len
    '.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon': {
      marginLeft: '.5em'
    },
    '.emoji-mart-preview-emoticon': {
      fontSize: '11px',
      color: '#bbb'
    },
    '.emoji-mart-title span': {
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    '.emoji-mart-title .emoji-mart-emoji': {
      padding: '0'
    },
    '.emoji-mart-title-label': {
      color: '#999A9C',
      fontSize: '26px',
      fontWeight: '300'
    },
    '.emoji-mart-skin-swatches': {
      fontSize: '0',
      padding: '2px 0',
      border: '1px solid #d9d9d9',
      borderRadius: '12px',
      backgroundColor: '#fff'
    },
    '.emoji-mart-skin-swatches.custom': {
      fontSize: '0',
      border: 'none',
      backgroundColor: '#fff'
    },
    '.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch': {
      width: '16px',
      padding: '0 2px'
    },
    '.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after': {
      opacity: '.75'
    },
    '.emoji-mart-skin-swatch': {
      display: 'inline-block',
      width: '0',
      verticalAlign: 'middle',
      transitionProperty: 'width, padding',
      transitionDuration: '.125s',
      transitionTimingFunction: 'ease-out'
    },
    '.emoji-mart-skin-swatch:nth-child(1)': {
      transitionDelay: '0s'
    },
    '.emoji-mart-skin-swatch:nth-child(2)': {
      transitionDelay: '.03s'
    },
    '.emoji-mart-skin-swatch:nth-child(3)': {
      transitionDelay: '.06s'
    },
    '.emoji-mart-skin-swatch:nth-child(4)': {
      transitionDelay: '.09s'
    },
    '.emoji-mart-skin-swatch:nth-child(5)': {
      transitionDelay: '.12s'
    },
    '.emoji-mart-skin-swatch:nth-child(6)': {
      transitionDelay: '.15s'
    },
    '.emoji-mart-skin-swatch.selected': {
      position: 'relative',
      width: '16px',
      padding: '0 2px'
    },
    '.emoji-mart-skin-swatch.selected:after': {
      content: '',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '4px',
      height: '4px',
      margin: '-2px 0 0 -2px',
      backgroundColor: '#fff',
      borderRadius: '100%',
      pointerEvents: 'none',
      opacity: '0',
      transition: 'opacity .2s ease-out'
    },
    '.emoji-mart-skin-swatch.custom': {
      display: 'inline-block',
      width: '0',
      height: '38px',
      overflow: 'hidden',
      verticalAlign: 'middle',
      transitionProperty: 'width, height',
      transitionDuration: '.125s',
      transitionTimingFunction: 'ease-out',
      cursor: 'default'
    },
    '.emoji-mart-skin-swatch.custom.selected': {
      position: 'relative',
      width: '36px',
      height: '38px',
      padding: '0 2px 0 0'
    },
    '.emoji-mart-skin-swatch.custom.selected:after': {
      content: '',
      width: '0',
      height: '0'
    },
    '.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover': {
      backgroundColor: '#f4f4f4',
      borderRadius: '10%'
    },
    '.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom': {
      width: '36px',
      height: '38px',
      padding: '0 2px 0 0'
    },
    '.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after': {
      opacity: '.75'
    },
    '.emoji-mart-skin-text.opened': {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left',
      color: '#888',
      fontSize: '11px',
      padding: '5px 2px',
      width: '95px',
      height: '40px',
      borderRadius: '10%',
      backgroundColor: '#fff'
    },
    '.emoji-mart-skin': {
      display: 'inline-block',
      width: '100%',
      paddingTop: '100%',
      maxWidth: '12px',
      borderRadius: '100%'
    },
    '.emoji-mart-skin-tone-1': {
      backgroundColor: '#ffc93a'
    },
    '.emoji-mart-skin-tone-2': {
      backgroundColor: '#fadcbc'
    },
    '.emoji-mart-skin-tone-3': {
      backgroundColor: '#e0bb95'
    },
    '.emoji-mart-skin-tone-4': {
      backgroundColor: '#bf8f68'
    },
    '.emoji-mart-skin-tone-5': {
      backgroundColor: '#9b643d'
    },
    '.emoji-mart-skin-tone-6': {
      backgroundColor: '#594539'
    },
    '.emoji-mart-sr-only': {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      border: '0'
    }
  }
});
exports.default = _default;